import React, { useState, useRef, useEffect } from 'react';
import './Contact.css';
import config from './config';

const Contact = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [error, setError] = useState('');
  
  
  const heroRef = useRef(null);
  
  useEffect(() => {
  
    if (heroRef.current) {
      setTimeout(() => {
        heroRef.current.style.opacity = "1";
        heroRef.current.style.transform = "translateY(0)";
      }, 300);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    
    if (name === 'phone') {
     
      const numbersOnly = value.replace(/\D/g, '').slice(0, 11);
      setFormData({
        ...formData,
        [name]: numbersOnly
      });
      return;
    }

    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

   
    if (formData.phone && formData.phone.length !== 11) {
      setError('Phone number must be exactly 11 digits');
      return;
    }

    
    if (formData.mobile && !/^\d{1,11}$/.test(formData.mobile)) {
      setError('Mobile number must contain only numbers and be up to 11 digits');
      return;
    }

   
    if (!formData.name || !formData.email || !formData.message) {
      alert('Please fill in all mandatory fields!');
      return; 
    }

    if (formData.message.length < 30) {
      alert('Message is too short. Please explain a bit more');
      return; 
    }

    try {
      
      const response = await fetch(`${config.apiBaseUrl}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to send message');
      }

      setIsSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    } catch (error) {
      console.error('Error:', error);
      alert(error.message || 'Failed to send message. Please try again later.');
    }
  };

  return (
    <div>
      <section className="contact-hero" 
        ref={heroRef}
        style={{ opacity: "0", transform: "translateY(-20px)", transition: "all 1s ease" }}
      >
        <div className="hero-text">
          <h1>Contact Us</h1>
          <p className="contact-text">Connect with us</p>
        </div>
      </section>

      {/* Our Leadership Section */}
      <section className="leadership-container">
        <h2>Our Leadership</h2>
        <div className="leadership-profiles">
          <div className="leadership-profile">
            <img
              src="https://t3.ftcdn.net/jpg/05/16/27/58/360_F_516275801_f3Fsp17x6HQK0xQgDQEELoTuERO4SsWV.jpg"
              alt="Pr. Godly Mathew"
              className="profile-image"
            />
            <h3>Pr. Godly Mathew</h3>
            <p>godly.mathew@faithtabernaclechurch.co.uk</p>
            <p>
            Pr. Godly is the Head of Ministry at Faith Tabernacle Church. He is
            passionate about serving the church.
            </p>
          </div>

          <div className="leadership-profile">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUmZ7_GiKXbJ40JkndDcbinZnwbg4Fx1CJdQ&s"
              alt="Pr. Finney Mathew"
              className="profile-image"
            />
            <h3>Pr. Finney Mathew</h3>
            <p>finney.mathew@faithtabernaclechurch.co.uk</p>
            <p>
            Pr. Finney is the Senior Pastor at Faith Tabernacle Church. He is
            dedicated to helping people grow in their faith.
            </p>
          </div>
        </div>
      </section>

      <section className="contact-container">
        <div className="contact-info">
          <h2>Contact Us</h2>
          <p>
            If you have any questions or need more information, feel free to
            reach out to us. Our team is here to assist you!
          </p>

          <div className="address">
            <h3>Our Address</h3>
            <p>3 Alexandra St, Kettering NN16 0SX, UK</p>
            <p>Email: contactus@faithtabernaclechurch.co.uk</p>
          </div>
        </div>

        <div className="contact-form">
          <h2>Get in Touch</h2>
          <form onSubmit={handleSubmit}>
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label htmlFor="phone">Phone Number (optional)</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="07123456789"
            />

            {error && <div className="error-message">{error}</div>}

            <label htmlFor="message">Your Message</label>
            <textarea
              id="message"
              name="message"
              placeholder="Prayer requests/additional information"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              required
            ></textarea>

            <button type="submit">Submit</button>
          </form>
        </div>

        {/* Confirmation Modal */}
        {isSubmitted && (
          <div className="confirmation-popup">
            <div className="popup-content">
              <h3>Form Submitted!</h3>
              <p>
                Thank you for contacting us. We will get back to you soon.
              </p>
              <button onClick={() => setIsSubmitted(false)}>Close</button>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default Contact;
